<template>
  <div class="loading-overlay">
    <span class="mdi mdi-loading mdi-spin" />
  </div>
</template>
<script>
export default {
  name: 'loading-overlay-component',
};
</script>
<style scoped>
.loading-overlay {
  font-size: 60px;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1000000;
  top: 0;
  left: 0;
  background-color: white;
  opacity: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
